import type { RichTextAnswerFragment } from '../../../present/activity-answers.graphql.generated';
import type { SuggestedAnswerFragment } from '../../suggested-answers/suggested-answers.graphql.generated';
import type { Pluck } from 'lib/gql/pluck';

export function getRichtextAnswer(
  answer:
    | {
        uuid: string;
        answer: Pluck<
          SuggestedAnswerFragment,
          'suggestedAnswers.answer'
        > | null;
      }
    | null
    | undefined
) {
  return (answer?.answer as RichTextAnswerFragment)?.richtext;
}
